import WaveSurfer from 'wavesurfer.js'
window.WaveSurfer = WaveSurfer
